<template>
	<div>
		<v-row>
			<v-col cols="6">
				<div class="text-h6 text-left">{{ place.name }}</div>
				<div class="caption text-left" v-if="place.services.length">
					Servicio: {{ place.services[0].name }}
				</div>
				<div class="caption text-left" v-if="place.address">
					Lugar perimetral: {{ place.address }}
				</div>
				<div class="text-left error--text">
					{{ pendingLodgings }} actividades a realizar
				</div>
				<div class="text-left error--text">
					Durante el mes, se han realizado {{ completedLodgings }} actividades
				</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="6" lg="5" xl="5">
				<v-text-field
					dense
					filled
					v-model="place.name"
					label="Nombre del establecimiento"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5" xl="5">
				<v-text-field filled dense v-model="place.rut" label="Rut" outlined hide-details />
			</v-col>
			<v-col cols="12" sm="6" lg="5" xl="5">
				<v-text-field
					dense
					filled
					v-model="place.cliente"
					label="Cliente"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					dense
					filled
					v-model="place.direction"
					label="Direccion"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-select
					dense
					solo
					:items="placeTypes"
					item-text="label"
					item-value="value"
					placeholder="Domicilio/Empresa"
					outlined
					label="Tipo de lugar"
					filled
					hide-details
					v-model="place.type"
			/></v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					dense
					filled
					v-model="place.email[0]"
					label="Correo 1"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.email[1]"
					label="Correo 2"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.city"
					label="Ciudad/comuna"
					outlined
					hide-details
				/>
			</v-col>

			<v-col cols="12" sm="6" lg="5">
				<v-select
					class="mx-1"
					v-model="place.region"
					:items="regiones"
					item-text="region"
					item-value="region"
					dense
					solo
					filled
					outlined
					autocomplete="off"
					persistent-hint
					hint="Region"
				>
				</v-select>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.nombreSolicitante"
					label="Nombre solicitante"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.rutSolicitante"
					label="Rut solicitante"
					outlined
					hide-details
				/>
			</v-col>

			<v-col cols="12" sm="6" lg="5">
				<v-select
					class="mx-1"
					v-model="place.frecuenciaCorreos"
					:items="['Mensual', 'Diario', 'Default']"
					default="Default"
					solo
					dense
					outlined
					filled
					persistent-hint
					hint="Frecuencia correos"
				></v-select>
			</v-col>
			<v-col cols="12" sm="6" lg="5" v-if="place.frecuenciaCorreos !== 'Default'">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:nudge-right="40"
					:return-value.sync="place.horaCorreos"
					transition="scale-transition"
					offset-y
					max-width="290px"
					min-width="290px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							solo
							v-model="place.horaCorreos"
							persistent-hint
							hint="Hora a la que se enviaran los correos"
							readonly
							outlined
							dense
							filled
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-time-picker
						v-if="menu"
						v-model="place.horaCorreos"
						format="24hr"
						full-width
						@click:minute="$refs.menu.save(place.horaCorreos)"
					></v-time-picker>
				</v-menu>
			</v-col>
			<!-- <v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.direccionSolicitante"
					label="Direccion solicitante"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.comunaSolicitante"
					label="Comuna solicitante"
					outlined
					hide-details
				/>
			</v-col>
			<v-col cols="12" sm="6" lg="5">
				<v-text-field
					filled
					dense
					v-model="place.direccionPropietario"
					label="Direccion propietario"
					outlined
					hide-details
				/>
			</v-col> -->
			<v-col cols="12" offset-sm="8" sm="4" offset-lg="0" lg="2" xl="2">
				<v-btn block small color="success" :loading="loading" @click="submit" class="mt-1">
					<v-icon small left>mdi-content-save-outline</v-icon>
					Actualizar
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import regiones from '@/assets/comunas-regiones.json';

export default {
	props: {
		place: {
			type: Object,
			required: true,
		},
	},
	components: {},
	data() {
		return {
			regiones,
			today: moment(),
			placeTypes: ['Empresa', 'Domicilio'],
			loading: false,
			menu: undefined,
		};
	},
	computed: {
		pendingLodgings() {
			if (this.place.lodgings) {
				let pendingLodgings = this.place.lodgings.filter(lodging => {
					const endDate = moment(lodging.end);
					return this.today.isBefore(endDate);
				});
				return pendingLodgings.length;
			}
			return 0;
		},
		completedLodgings() {
			if (this.place.lodgings) {
				let completedLodgings = this.place.lodgings.filter(lodging => {
					const endDate = moment(lodging.end);
					return this.today.isAfter(endDate);
				});
				return completedLodgings.length;
			}
			return 0;
		},
	},
	methods: {
		async submit() {
			this.loading = true;
			await this.updatePlace({
				payload: {
					name: this.place.name,
					rut: this.place.rut,
					cliente: this.place.cliente,
					direction: this.place.direction,
					city: this.place.city,
					region: this.place.region,
					email: this.place.email,
					nombreSolicitante: this.place.nombreSolicitante,
					rutSolicitante: this.place.rutSolicitante,
					direccionSolicitante: this.place.direccionSolicitante,
					comunaSolicitante: this.place.comunaSolicitante,
					direccionPropietario: this.place.direccionPropietario,
					horaCorreos: this.place.horaCorreos,
					frecuenciaCorreos: this.place.frecuenciaCorreos,
					type: this.place.type,
				},
				placeId: this.place._id,
			});
			this.loading = false;
		},
		...mapActions({
			updatePlace: 'Place/updatePlace',
		}),
	},
};
</script>

<style lang="scss" scoped></style>
